import { NgModule } from '@angular/core';
import { SidebarComponent } from '../sidebar/sidebar.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { IconsProviderModule } from '../icons-provider.module';
import { provideHttpClient } from '@angular/common/http';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { provideNzI18n, en_US } from 'ng-zorro-antd/i18n';
import { ClientDrawerComponent } from './client-drawer/client-drawer.component';
import { TaskDrawerComponent } from './task-drawer/task-drawer.component';
import { ProjectDrawerComponent } from './project-drawer/project-drawer.component';
import { NgZorroAntdModule } from '../ng-zorro-antd.module';
import { CommonModule } from '@angular/common';
import { ConsoleClientTabComponent } from './console-client-tab/console-client-tab.component';
import { ConsoleProjectDetailComponent } from './console-project-detail/console-project-detail.component';
import { ConsoleProjectTabComponent } from './console-project-tab/console-project-tab.component';
import { ConsoleTaskTabComponent } from './console-task-tab/console-task-tab.component';
import { MasterSearchComponent } from './master-search/master-search.component';
import { NzListModule } from 'ng-zorro-antd/list';
import { NzTreeViewModule } from 'ng-zorro-antd/tree-view';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzSegmentedModule } from 'ng-zorro-antd/segmented';
import { CpdOverviewComponent } from './console-project-detail/cpd-overview/cpd-overview.component';
import { CpdTasksComponent } from './console-project-detail/cpd-tasks/cpd-tasks.component';
import { CpdPeopleComponent } from './console-project-detail/cpd-people/cpd-people.component';
import { CpdEventsComponent } from './console-project-detail/cpd-events/cpd-events.component';
import { CpdFilesComponent } from './console-project-detail/cpd-files/cpd-files.component';
import { CpdDriveLinksComponent } from './console-project-detail/cpd-drive-links/cpd-drive-links.component';
import { CpdHistoryComponent } from './console-project-detail/cpd-history/cpd-history.component';

import { QuillModule } from 'ngx-quill';
import { LoaderComponent } from './loader/loader.component';
import { ProjectPlanDrawerComponent } from './project-plan-drawer/project-plan-drawer.component';
import { AddProjectPlanComponent } from './add-project-plan/add-project-plan.component';
import { AddCostApprovalComponent } from './add-cost-approval/add-cost-approval.component';
import { QuestionInputComponent } from './project-plan-drawer/question-input/question-input.component';
import { LinksComponent } from './project-drawer/links/links.component';
import { TaskHistoryComponent } from './task-history/task-history.component';
import { NzPopconfirmModule } from 'ng-zorro-antd/popconfirm';
import { ClientAddPocComponent } from './client-add-poc/client-add-poc.component';
import { ClientAddAddressComponent } from './client-add-address/client-add-address.component';
import { ClientPocDetailComponent } from './client-poc-detail/client-poc-detail.component';
import { ClientAddressDetailComponent } from './client-address-detail/client-address-detail.component';
import { EventDrawerComponent } from './event-drawer/event-drawer.component';
import { ConsoleEventTabComponent } from './console-event-tab/console-event-tab.component';
import { CetDashboardComponent } from './console-event-tab/cet-dashboard/cet-dashboard.component';
import { CetTasksComponent } from './console-event-tab/cet-tasks/cet-tasks.component';
import { CetOutsourcingComponent } from './console-event-tab/cet-outsourcing/cet-outsourcing.component';
import { CetQuotationsComponent } from './console-event-tab/cet-quotations/cet-quotations.component';
import { CetInvoicesComponent } from './console-event-tab/cet-invoices/cet-invoices.component';
import { CetPaymentsComponent } from './console-event-tab/cet-payments/cet-payments.component';
import { CetNotesComponent } from './console-event-tab/cet-notes/cet-notes.component';
import { CompareQuotationsComponent } from './console-event-tab/compare-quotations/compare-quotations.component';
import { CetInquiryComponent } from './console-event-tab/cet-inquiry/cet-inquiry.component';
import { CetInquiryModalComponent } from './console-event-tab/cet-inquiry/cet-inquiry-modal/cet-inquiry-modal.component';
import { CetPaymentModalComponent } from './console-event-tab/cet-payments/cet-payment-modal/cet-payment-modal.component';
import { CetInvoicesModalComponent } from './console-event-tab/cet-invoices/cet-invoices-modal/cet-invoices-modal.component';
import { CetVendorRequestsComponent } from './console-event-tab/cet-vendor-requests/cet-vendor-requests.component';
import { VendorRequestModalComponent } from './console-event-tab/cet-vendor-requests/vendor-request-modal/vendor-request-modal.component';
import { VendorDrawerComponent } from './vendor-drawer/vendor-drawer.component';
import { CetInvoiceDetailsComponent } from './cet-invoice-details/cet-invoice-details.component';
import { CetPaymentsDetailsComponent } from './cet-payments-details/cet-payments-details.component';
import { CetVendorDetailsComponent } from './console-event-tab/cet-vendor-details/cet-vendor-details.component';
import { NzCheckboxModule } from 'ng-zorro-antd/checkbox';
import { NzRadioModule } from 'ng-zorro-antd/radio';
import { VendorSubmissionModalComponent } from './vendor-submission-modal/vendor-submission-modal.component';
import { AdvancedPaymentsComponent } from './console-event-tab/advanced-payments/advanced-payments.component';
import { AddAdvancePaymentComponent } from './console-event-tab/advanced-payments/add-advance-payment/add-advance-payment.component';
import { AdvancedPaymentDetailsComponent } from './advanced-payment-details/advanced-payment-details.component';
import { VendorAddPocComponent } from './vendor-add-poc/vendor-add-poc.component';
import { VendorPocDetailsComponent } from './vendor-poc-details/vendor-poc-details.component';
import { GenarateClientPptComponent } from './console-event-tab/genarate-client-ppt/genarate-client-ppt.component';
import { VenueDrawerComponent } from './venue-drawer/venue-drawer.component';
import { VenueAddPocComponent } from './venue-add-poc/venue-add-poc.component';
import { VenueAddRoomComponent } from './venue-add-room/venue-add-room.component';
import { VenuePocDetailsComponent } from './venue-poc-details/venue-poc-details.component';
import { VenueRoomDetailsComponent } from './venue-room-details/venue-room-details.component';
import { VenuePocTableComponent } from './venue-poc-table/venue-poc-table.component';
import { VenueRoomTableComponent } from './venue-room-table/venue-room-table.component';
import { VenueRoomMediaLinkComponent } from './venue-room-media-link/venue-room-media-link.component';
import { CetComplianceSafetyComponent } from './console-event-tab/cet-compliance-safety/cet-compliance-safety.component';
import { GenerateEventPdfComponent } from './console-event-tab/generate-event-pdf/generate-event-pdf.component';
import { NgApexchartsModule } from 'ng-apexcharts';
import { CetSourcingNeedsV2Component } from "./console-event-tab/cet-sourcing-needs-v2/cet-sourcing-needs-v2.component";
import { SnFormVenueV2Component } from './console-event-tab/cet-sourcing-needs-v2/modals/sn-form-venue-v2/sn-form-venue-v2.component';
import { SnFormCateringV2Component } from './console-event-tab/cet-sourcing-needs-v2/modals/sn-form-catering-v2/sn-form-catering-v2.component';
import { SnFormPhotoVideoV2Component } from './console-event-tab/cet-sourcing-needs-v2/modals/sn-form-photo-video-v2/sn-form-photo-video-v2.component';
import { SnFormBrandingV2Component } from './console-event-tab/cet-sourcing-needs-v2/modals/sn-form-branding-v2/sn-form-branding-v2.component';
import { SnFormGiftV2Component } from './console-event-tab/cet-sourcing-needs-v2/modals/sn-form-gift-v2/sn-form-gift-v2.component';
import { SnFormTransportV2Component } from './console-event-tab/cet-sourcing-needs-v2/modals/sn-form-transport-v2/sn-form-transport-v2.component';
import { SnFormSpeakerTalentV2Component } from './console-event-tab/cet-sourcing-needs-v2/modals/sn-form-speaker-talent-v2/sn-form-speaker-talent-v2.component';
import { SnFormFurnitureV2Component } from './console-event-tab/cet-sourcing-needs-v2/modals/sn-form-furniture-v2/sn-form-furniture-v2.component';
import { SnFormAvV2Component } from './console-event-tab/cet-sourcing-needs-v2/modals/sn-form-av-v2/sn-form-av-v2.component';
import { SnFormExperienceV2Component } from './console-event-tab/cet-sourcing-needs-v2/modals/sn-form-experience-v2/sn-form-experience-v2.component';
import { SnFormProductionFabricationV2Component } from './console-event-tab/cet-sourcing-needs-v2/modals/sn-form-production-fabrication-v2/sn-form-production-fabrication-v2.component';
import { CommonSourcingViewComponent } from './console-event-tab/cet-sourcing-needs-v2/common-sourcing-view/common-sourcing-view.component';
import { OverviewComponentComponent } from './console-event-tab/cet-sourcing-needs-v2/overview-component/overview-component.component';
import { IsObjectPipe } from '../pipes/is-object.pipe';
import { ObjectKeysPipe } from '../pipes/object-keys.pipe';
import { ModeratorModalComponent } from './console-event-tab/cet-dashboard/moderator-modal/moderator-modal.component';
//  import { NzRateModule } from 'ng-zorro-antd/rate';
@NgModule({
  declarations: [
    ClientDrawerComponent,
    TaskDrawerComponent,
    ProjectDrawerComponent,
    ConsoleProjectDetailComponent,
    ConsoleClientTabComponent,
    ConsoleProjectTabComponent,
    ConsoleTaskTabComponent,
    MasterSearchComponent,
    CpdOverviewComponent,
    CpdTasksComponent,
    CpdPeopleComponent,
    CpdEventsComponent,
    CpdFilesComponent,
    CpdDriveLinksComponent,
    CpdHistoryComponent,
    ClientAddPocComponent,
    ClientAddAddressComponent,
    ProjectPlanDrawerComponent,
    AddProjectPlanComponent,
    AddCostApprovalComponent,
    QuestionInputComponent,
    LinksComponent,
    LoaderComponent,
    TaskHistoryComponent,
    ClientPocDetailComponent,
    ClientAddressDetailComponent,
    EventDrawerComponent,
    ConsoleEventTabComponent,
    CetDashboardComponent,
    CetTasksComponent,
    CetOutsourcingComponent,
    CetQuotationsComponent,
    CetInvoicesComponent,
    CetPaymentsComponent,
    CetNotesComponent,
    CompareQuotationsComponent,
    CetInquiryComponent,
    CetInquiryModalComponent,
    CetPaymentModalComponent,
    CetInvoicesModalComponent,
    CetVendorRequestsComponent,
    VendorRequestModalComponent,
    VendorDrawerComponent,
    CetInvoiceDetailsComponent,
    CetPaymentsDetailsComponent,
    CetVendorDetailsComponent,
    VendorSubmissionModalComponent,
    AdvancedPaymentsComponent,
    AddAdvancePaymentComponent,
    AdvancedPaymentDetailsComponent,
    VendorAddPocComponent,
    VendorPocDetailsComponent,
    GenarateClientPptComponent,
    VenueDrawerComponent,
    VenueAddPocComponent,
    VenueAddRoomComponent,
    VenuePocDetailsComponent,
    VenueRoomDetailsComponent,
    VenuePocTableComponent,
    VenueRoomTableComponent,
    VenueRoomMediaLinkComponent,
    CetComplianceSafetyComponent,
    GenerateEventPdfComponent,
    CetSourcingNeedsV2Component,
    SnFormVenueV2Component,
    SnFormCateringV2Component,
    SnFormPhotoVideoV2Component,
    SnFormBrandingV2Component,
    SnFormGiftV2Component,
    SnFormTransportV2Component,
    SnFormSpeakerTalentV2Component,
    SnFormFurnitureV2Component,
    SnFormAvV2Component,
    SnFormExperienceV2Component,
    SnFormProductionFabricationV2Component,
    CommonSourcingViewComponent,
    OverviewComponentComponent,
    ModeratorModalComponent,

  ],
  exports: [
    ClientDrawerComponent,
    TaskDrawerComponent,
    ProjectDrawerComponent,
    ConsoleProjectDetailComponent,
    ConsoleClientTabComponent,
    ConsoleProjectTabComponent,
    ConsoleTaskTabComponent,
    MasterSearchComponent,
    CpdOverviewComponent,
    CpdTasksComponent,
    CpdPeopleComponent,
    CpdEventsComponent,
    CpdFilesComponent,
    CpdDriveLinksComponent,
    CpdHistoryComponent,
    ClientAddPocComponent,
    ClientAddAddressComponent,
    ProjectPlanDrawerComponent,
    AddProjectPlanComponent,
    AddCostApprovalComponent,
    QuestionInputComponent,
    LinksComponent,
    LoaderComponent,
    TaskHistoryComponent,
    ClientPocDetailComponent,
    ClientAddressDetailComponent,
    EventDrawerComponent,
    ConsoleEventTabComponent,
    VendorDrawerComponent,
    VenueAddPocComponent,
    VenueAddRoomComponent,
    VenuePocDetailsComponent,
    VenueRoomDetailsComponent,
    VenuePocTableComponent,
    VenueRoomTableComponent,
    VenueRoomMediaLinkComponent,
    ModeratorModalComponent,
    // CetComplianceSafetyComponent,

  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    NzCheckboxModule,
    NzRadioModule,
    IconsProviderModule,
    NgZorroAntdModule,
    NgApexchartsModule,
    NzListModule,
    NzTreeViewModule,
    NzIconModule,
    NzSegmentedModule,
    NzPopconfirmModule,
    QuillModule.forRoot(),
    IsObjectPipe,
    ObjectKeysPipe,
],
  providers: [],
})
export class ComponentsModule {}
